import React, {useContext, useState} from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import DeleteIcon from '@mui/icons-material/Delete';
import {UserContext} from "../contexts/user-context";
import {useEffect} from 'react';

export default function SplitButton({buttonStyle, options, setSelectedId, loadFields, propName, setOpenSnackbar, setToastMessage, setResponseOption }) {
  const userContext = useContext(UserContext);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState<null|number>();

  const resultArray = options.map((item) => {
  const [id, name] = item.split('.');
    return { id, name };
  });
  console.log("optionssss---", resultArray);
  const handleClick = () => {
      const clickedId = resultArray[selectedIndex!].id;
      loadFields(false, clickedId);
      console.info('You clicked', clickedId);
  };
  const deleteIconStyle = {
    marginRight: '15px',
    cursor: 'not-allowed',
  };
  const handleDelete = async (id) => {
    console.log("Delete search ID" , id)
    const response  = await userContext.setDelete(propName + '-search', id, setOpenSnackbar, setToastMessage ); 
    setResponseOption(response);
  }
  // useEffect(() => {
  //   if (setToastMessage && setOpenSnackbar) {
  //     // Call loadFields when toastMessage changes
  //     // Pass appropriate arguments to loadFields (false and clickedId)
  //     loadFields(false, '');
  //   }
  // }, [setToastMessage, setOpenSnackbar, loadFields]);

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };
  return (
    <React.Fragment>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        aria-label="split button"
        style={buttonStyle}
      >
        <Button onClick={handleClick}>
        {
          typeof selectedIndex === 'number' && selectedIndex >= 0 && selectedIndex < resultArray.length
            ? resultArray[selectedIndex].name
            : "Select Search"
        }
        </Button>
        <Button
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1500,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {resultArray.map((option, index) => (
                    <MenuItem
                      key={option.id}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      <DeleteIcon onClick={() => handleDelete(option.id)} style={deleteIconStyle} /> {option.name} 
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}